import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgPaddle24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Paddle",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 9.558C19 5.39 15.635 2 11.5 2S4 5.39 4 9.558a7.57 7.57 0 0 0 4.162 6.759c.028.016.05.04.08.053.18.07.595.236.59 1.202l.002 2.648c-.041.53.228 1.014.739 1.329.486.3 1.209.451 1.93.451.718 0 1.436-.149 1.92-.447.512-.314.782-.8.745-1.275v-2.71c-.006-.962.41-1.127.588-1.198.03-.012.052-.036.08-.052A7.57 7.57 0 0 0 19 9.558m-6.318 10.695c-.13.1-.547.25-1.177.25-.632 0-1.053-.15-1.187-.25v-2.677a4 4 0 0 0-.034-.569c.397.066.801.109 1.215.109s.82-.043 1.216-.108a4 4 0 0 0-.034.564zm-1.183-4.635c-3.316 0-6.012-2.72-6.012-6.06 0-3.341 2.697-6.06 6.012-6.06 3.316 0 6.013 2.719 6.013 6.06s-2.696 6.06-6.013 6.06"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 1.5,
  x: 8.553,
  y: 9,
  rx: 0.75
}));

export { SvgPaddle24 as default };
//# sourceMappingURL=Paddle24.js.map
